import { BaseError } from 'make-error';

export class PromiseTimeoutError extends BaseError {
    constructor(message?: string) {
        super(message ?? 'The promise timed-out before it could complete.');
    }
}

/**
 * @throws :{@link PromiseTimeoutError}
 * Thrown if timeout occurs before the promise completes.
 */
export function timeout<T>(p: Promise<T>, delayMs: number): Promise<T> {
    return Promise.race([
        p,
        new Promise<never>((_, reject) => {
            setTimeout(() => {
                reject(new PromiseTimeoutError());
            }, delayMs);
        }),
    ]);
}
